import ModalBody from "./components/ModalBody";
import Module, { React } from "xolabot-sdk";
import config from "./config.json";
import { store } from "./store";
import sortBy from "lodash/sortBy";
import keyBy from "lodash/keyBy";
import { getProductAddOns } from "./helpers";

class UpsellAddonsModule extends Module {
    static APP_ID = config.plugin.id;

    experience = null;
    purchased = false;
    addOnsSelected = false;
    addOnsCount = 0;

    constructor(options) {
        super("addon_upsell", options);

        // X1
        this.stopHandleOrderInfo = this.bus.on(
            { channel: this.channels.CHECKOUT_COLLECTOR, type: "order_info" },
            this.handleOrderOrPurchaseInfo,
        );

        // X2
        this.stopHandlePurchaseInfo = this.bus.on(
            { channel: this.channels.CHECKOUT_COLLECTOR, type: "purchase_info" },
            this.handleOrderOrPurchaseInfo,
        );

        // X1
        this.stopHandleTagOrders = this.bus.on(
            { channel: this.channels.CHECKOUT_COLLECTOR, type: "order_info" },
            this.handleTagOrders,
        );

        // X2
        this.stopHandleTagOrders = this.bus.on(
            { channel: this.channels.CHECKOUT_COLLECTOR, type: "purchase_info" },
            this.handleTagOrders,
        );

        // X1
        this.bus.on({ channel: this.channels.CHECKOUT_COLLECTOR, type: "order_info" }, this.handleDetectPurchase);

        // X2
        this.bus.on({ channel: this.channels.CHECKOUT_COLLECTOR, type: "order_info" }, this.handleDetectPurchase);

        this.bus.on({ channel: this.channels.CHECKOUT, type: "closed" }, this.handleDetectCheckoutClosed);
    }

    handleDetectCheckoutClosed = () => {
        if (this.addOnsSelected) {
            this.addOnsSelected = false;

            if (this.purchased) {
                this.drop();
            }
        }
    };

    handleDetectPurchase = ({ purchased, demographics_quantity }) => {
        if (this.addOnsSelected && purchased && demographics_quantity > 0) {
            this.purchased = true;
        }
    };

    handleTagOrders = ({ reached_payment_page, demographics_quantity, add_ons_quantity }) => {
        const isNewXolaBotAddonAdded = this.addOnsCount < add_ons_quantity;
        if (reached_payment_page && this.addOnsSelected && demographics_quantity > 0 && isNewXolaBotAddonAdded) {
            // For X1
            this.checkout.xwm.checkout.send("tag_orders", "XolaBot");
            this.checkout.xwm.checkout.send("tag_orders", "XolaBot - Upsell Add-ons");
            // For X2
            this.checkout.xwm.checkout.send("tag_purchases", "XolaBot");
            this.checkout.xwm.checkout.send("tag_purchases", "XolaBot - Upsell Add-ons");
            this.stopHandleTagOrders();
        }
    };

    fetchExperience = async (sellerId, experienceId) => {
        const { data } = await this.api.get(`/api/experiences/${experienceId}`, {
            params: { seller: sellerId },
        });

        return data;
    };

    handleOrderOrPurchaseInfo = async (orderOrPurchaseInfo) => {
        this.addOnsCount = orderOrPurchaseInfo.add_ons_quantity;
        // we want to prefetch selected experience so we don't delay the popup on the payment page
        if (
            (orderOrPurchaseInfo.experience_id && !this.experience) ||
            (orderOrPurchaseInfo.experience_id &&
                this.experience &&
                this.experience.id !== orderOrPurchaseInfo.experience_id)
        ) {
            this.experience = await this.fetchExperience(
                orderOrPurchaseInfo.seller_id,
                orderOrPurchaseInfo.experience_id,
            );
        }

        if (
            orderOrPurchaseInfo.item_count > 0 &&
            orderOrPurchaseInfo.reached_payment_page &&
            orderOrPurchaseInfo.experience_id &&
            orderOrPurchaseInfo.add_ons_quantity === 0
        ) {
            const experience =
                this.config.experiences &&
                this.config.experiences.find((experience) => experience.id === orderOrPurchaseInfo.experience_id);

            if (!experience) {
                return;
            }

            if (experience && experience.addons.length === 0) {
                return;
            }

            const { setState } = store;

            this.stopHandleOrderInfo();
            this.stopHandlePurchaseInfo();

            if (getProductAddOns(this.experience).length === 0) {
                return;
            }

            const addons = experience.addons.reduce((addons, configAddon) => {
                const foundAddon = getProductAddOns(this.experience).find((addon) => {
                    return configAddon.id === addon.id || (addon.code && addon.code === configAddon.id);
                });

                if (foundAddon) {
                    //incase of migrated seller, addOn catalog id will be different, so assigning new catalog id
                    if (configAddon.id !== foundAddon.id) {
                        addons.push({ ...foundAddon, ...configAddon, id: foundAddon.id });
                    } else {
                        addons.push({ ...foundAddon, ...configAddon });
                    }
                }

                return addons;
            }, []);

            setState({ addons: keyBy(addons, "id") });

            const score = { confidence: 0.6, value: 5 };

            this.notify(score, {
                type: "modal",
                message: this.config.title,

                render: () => (
                    <ModalBody
                        addons={sortBy(addons, ["sequence"])}
                        onAddToCartClick={this.handleAddToCartClick}
                        onCancelClick={this.handleCancelClick}
                        description={this.config.description || ""}
                    />
                ),
            });
        }
    };

    handleCancelClick = () => {
        this.bus.emit({ channel: this.channels.UI, type: "close_modal" }, { name: this.name });
    };

    handleAddToCartClick = () => {
        this.bus.emit({ channel: this.channels.UI, type: "close_modal" }, { name: this.name });
        const { addons } = store.getState();
        this.addOnsSelected = Object.values(addons).some((addon) => addon.quantity);

        this.checkout.xwm.checkout.send("add_addons", {
            productId: this.experience.id,
            addons: Object.values(addons),
        });
    };
}

UpsellAddonsModule.load();
